import { Component, OnInit, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms'

import { NgbDateStructAdapter } from '@ng-bootstrap/ng-bootstrap/datepicker/adapters/ngb-date-adapter';

import Swal from 'sweetalert2';

import { AuthenticationService } from 'app/auth/service';
import { OperationService } from 'app/service/operation/operation.service';
import { AlertService } from 'app/service/alert/alert.service';
import { ProofComponent } from '../../operation/proof/proof.component';
import { DomainService } from 'app/service/domain/domain.service';
import { BudgetService } from 'app/service/budget/budget.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-budget-cash-donation',
  templateUrl: './budget-cash-donation.component.html',
  styleUrls: ['./budget-cash-donation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BudgetCashDonationComponent implements OnInit {

  currentUser = Object.freeze(this.authenticationService.currentUserValue);
  @ViewChild(ProofComponent) child !: any;
  @ViewChildren(ProofComponent)

  public currentBudget
  public domains
  public subdomains

  public basicDPdata: NgbDateStructAdapter;

  submittedOperationId

  proofExist = false

  public createDonationOperationForm: FormGroup;
  public donationOperationSubmitted = false
  public loadingSubmitCashDonation = false

  constructor(
    private authenticationService: AuthenticationService,
    private budgetService: BudgetService,
    private domainService: DomainService,
    private operationService: OperationService,
    private _formBuilder: FormBuilder,
    private alertService: AlertService,
    private route: ActivatedRoute) { }

  // convenience getter for easy access to donation operation form fields
  get d_o() {
    return this.createDonationOperationForm.controls;
  }

  submitCashDonation(res) {
    if (res.value == true) {
      this.loadingSubmitCashDonation = true
      let label = 'cash_donation'
      let cash_amount = this.currentBudget.cash_amount + this.d_o.amount.value
      this.operationService.cashDonation(this.currentUser.id, null, this.currentBudget.id, label, this.d_o.title.value, this.d_o.note.value, this.d_o.reference.value, this.d_o.domain.value, this.d_o.operation_date.value, this.d_o.amount.value, cash_amount, this.currentBudget.bank_amount)
        .subscribe({
          next: (operation) => {
            this.child.submitProof(operation)
            this.loadingSubmitCashDonation = false
            this.donationOperationSubmitted = false
          },
          error: (e) => {
            this.loadingSubmitCashDonation = false
            this.donationOperationSubmitted = false
            console.error(e)
          }
        });
    }
  }

  confirmOperation() {
    this.donationOperationSubmitted = true
    if (this.createDonationOperationForm.invalid) {
      return
    } else {
      if (this.proofExist) {
        Swal.fire({
          title: 'Are you sure you want to go through this transaction ?',
          text: `${this.d_o.amount.value} DT, will be transferred into your budget !`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#7367F0',
          cancelButtonColor: '#E42728',
          confirmButtonText: 'Yes, commit it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary ml-1'
          }
        }).then(res => this.submitCashDonation(res));
      } else {
        this.alertService.errorAlert('You cant commit this yet', 'You have to import at least one justification file');
      }
    }
  }

  handleProof(e) {
    if (!e) {
      this.proofExist = false
    } else {
      this.proofExist = true
    }
  }

  getDomains(): void {
    this.domainService.getDomainsByAssociation(this.currentUser.association_id)
      .subscribe({
        next: (data) => {
          this.domains = data
          this.subdomains = this.domains.flatMap(item => item.subdomains)
        },
        error: (e) => console.error(e)
      });
  }

  getBudgetData(): void {
    let id = this.route.snapshot.paramMap.get('id');
    this.budgetService.getBudget(id)
      .subscribe({
        next: (data) => {
          this.currentBudget = data;
        },
        error: (e) => console.error(e)
      });
  }

  ngOnInit(): void {
    this.getBudgetData();
    this.getDomains();

    //cash donation operation
    this.createDonationOperationForm = this._formBuilder.group({
      title: ['', Validators.required],
      note: [''],
      reference: ['', Validators.required],
      domain: ['', Validators.required],
      operation_date: [''],
      amount: ['', Validators.required],
    });
  }
}